
import { Vue, Component } from 'vue-property-decorator';
import APIService from '@/api';

@Component({
  components: {}
})
export default class ValidateToken extends Vue {
  service = new APIService();

  init() {
    const match = document.cookie.match(new RegExp('(^| )dashboard=([^;]+)'));
    if (match) {
      const access_token = match[2];
      this.service.setCredentials(access_token);
      window.location.assign('/');
    }
  }

  mounted() {
    this.init();
  }
}
